import { WA_URL } from '../data/constants';

export default function WhatsAppButton() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-float"
      aria-label="Contactar por WhatsApp"
    >
      <div className="wa-pulse" aria-hidden="true" />
      💬
    </a>
  );
}
